;(function () {
  'use strict'

  angular
    .module('contrast.trace.events')
    .factory(
      'traceEventTypeToClassService',
      traceEventTypeToClassServiceFactory
    )

  function traceEventTypeToClassServiceFactory() {
    'ngInject'

    // Maps trace event types to CSS classes
    var maps = {
      'trace-event-type-source': {
        Creation: true
      },
      'trace-event-type-propagation': {
        A2O: true,
        A2P: true,
        A2A: true,
        A2R: true,
        O2A: true,
        O2O: true,
        O2P: true,
        O2R: true,
        P2A: true,
        P2O: true,
        P2P: true,
        P2R: true
      },
      'trace-event-type-trigger': {
        Trigger: true
      },
      'trace-event-type-tag': {
        Tag: true
      }
    }

    return {
      get: get
    }

    function get(type) {
      var i,
        keys = Object.keys(maps),
        len,
        key,
        map
      for (i = 0, len = keys.length; i < len; i++) {
        key = keys[i]
        map = maps[key]
        if (map[type]) {
          return key
        }
      }
      return ''
    }
  }
})()
